module.exports = __webpack_public_path__ + "img/E490DE0C-673F-4968-9E7F-78CFD3FE0FC7 - 紅葉 もみじ・こうよう・クレハ.80c00fac.png";